import React, { ReactNode, MouseEvent } from 'react';
import styled from 'styled-components';
// --------------------------------------------------------------------------------
import { config } from '../index';

export interface ContentWrapperProps {
  /* Content background color */
  backgroundColor?: string;
  /* Content padding */
  padding?: string;
  /* Content margin */
  margin?: string;
  /* Content max width */
  maxWidth?: string;
  /* Content min height */
  minHeight?: string;
  /* Content additional config props */
  className?: string;
  /* Content children */
  children?: ReactNode;
  /* Header onClick callBack */
  onClick?: (event?: MouseEvent) => void;
}

const StyledContainer = styled.div<ContentWrapperProps>`
  position: relative;
  display: flex;
  flex-direction: column;
  width: 100%;

  padding: ${(props) => props.padding};
  max-width: ${(props) => props.maxWidth};
  min-height: ${(props) => props.minHeight};
`;

const StyledContentWrapper = styled.div<ContentWrapperProps>`
  display: flex;
  justify-content: center;
`;

const StyledWrapper = styled.div<ContentWrapperProps>`
  background-color: ${(props) => props.backgroundColor};
  margin: ${(props) => props.margin};
`;

export const ContentWrapper: React.FC<ContentWrapperProps> = ({
  backgroundColor = config.transparent,
  padding,
  margin,
  maxWidth,
  minHeight,
  children,
  onClick,
  ...props // additional props
}) => {
  return (
    <StyledWrapper
      backgroundColor={backgroundColor}
      margin={margin}
      onClick={onClick}
      {...props}
    >
      <StyledContentWrapper>
        <StyledContainer
          padding={padding}
          maxWidth={maxWidth}
          minHeight={minHeight}
        >
          {children}
        </StyledContainer>
      </StyledContentWrapper>
    </StyledWrapper>
  );
};
